import React, { useEffect, useState } from "react";
import { Input, Button, Switch, Modal } from "antd";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import productService from "../../service/product.service";
import { message } from "antd";

function Product() {
    const navigate = useNavigate();
    const { id } = useParams();

    const userLogado = useSelector((state) => state.usuarioLogado);

    const user = useSelector((state) => state.user);

    const [product, setProduct] = useState("");
    const [description, setDescription] = useState("");
    const [activo, setActivo] = useState(false);
    const [created_at, setCreated_At] = useState("");
    const [uidShipperBackup, setUidShipperBackup] = useState("");

    useEffect(() => {
        if (id) {
            loadProduct();
        }

    }, [id]);

    if (userLogado <= 0) {
        return <Navigate to="/login" />;
    }

    // CARREGAR PRODUCT (EDIÇÃO)
    async function loadProduct() {
        try {
            const snapshot = await productService.getProductByID(id);

            const data = snapshot.data();

            if (snapshot) {
                setProduct(data.product || "");
                setDescription(data.description || "");
                setActivo(data.activo || false);
                setCreated_At(data.created_at || "");
                setUidShipperBackup(data.uidShipper || "");
            }
            else {
                message.error("Produto não encontrado.");
                setTimeout(() => {
                    message.destroy();
                    navigate("/productList");
                }, 1500);
            }
        }
        catch (error) {
            message.error("Erro ao carregar o produto. Tente novamente.");
            console.error(error);
        }
    }

    // VALIDAÇÃO
    function validate() {
        if (!product) {
            message.warning("Atenção: verifique os campos: Produto.");
            return false;
        }

        return true;
    }

    // SALVAR / ATUALIZAR
    async function handleSave() {
        const isValid = validate();

        if (!isValid) {
            return;
        }

        const dados = {
            product: product,
            description: description,
            activo: activo,
            created_at: new Date(),
            uidShipper: user?.uidShipper,
            created_update: "",
        }

        try {
            await productService.postProduct(dados);

            message.success("Produto salvo com sucesso! ");

            setTimeout(() => {
                message.destroy();
                navigate("/productList");
            }, 1500);
        }
        catch (error) {
            message.error("Erro ao salvar o produto. Tente novamente.");
            console.error(error);
        }
    };

    async function handleUpdate() {
        const isValid = validate();

        if (!isValid) {
            return;
        }

        const dados = {
            product: product,
            description: description,
            activo: activo,
            created_at: created_at,
            uidShipper: uidShipperBackup !== user?.uidShipper ? [...uidShipperBackup, user?.uidShipper] : uidShipperBackup,
            created_update: new Date(),
        }

        try {
            await productService.updateProduct(id, dados);

            message.success("Produto atualizado com sucesso! ");

            setTimeout(() => {
                message.destroy();
                navigate("/productList");
            }, 1500);
        }
        catch (error) {
            message.error("Erro ao atualizar o produto. Tente novamente.");
            console.error(error);
        }
    };

    return (
        <NewMiniDrawer
            divOpen={
                <div className="freight-content">
                    <div className="container">
                        <h4>{id ? "Editar Produto" : "Cadastro de Produtos"}</h4>

                        <div className="row mt-4">
                            <div className="col-md-6">
                                <label> Produto <span style={{ color: "red" }}>*</span> </label>
                                <Input value={product} onChange={(e) => { setProduct(e.target.value); }} />
                            </div>

                            <div className="col-md-6">
                                <label>Ativo</label>
                                <br />
                                <Switch
                                    checked={activo}
                                    onChange={setActivo}
                                    style={{
                                        backgroundColor: activo ? "#012443" : "#d9d9d9",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-12">
                                <label>Descrição</label>
                                <Input.TextArea rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12 d-flex gap-2">
                                <div className="row mt-4">
                                    <div className="col-md-12 d-flex gap-2">
                                        <Button className="btn-form-fortio" onClick={() => navigate("/productList")} >
                                            Cancelar
                                        </Button>

                                        {id ? (
                                            <Button className="btn-form-fortio" onClick={handleUpdate} >
                                                Atualizar
                                            </Button>
                                        ) : (
                                            <Button className="btn-form-fortio" onClick={handleSave} >
                                                Salvar
                                            </Button>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            }
        />
    );
}

export default Product;